import Inline from '../blots/inline.js';
class Underline extends Inline {
  static blotName = 'underline';
  static tagName = 'U';
}
export default Underline;
